export const taskManagerTableData = {
    keys: [
        "smart_export",
        "task_name",
        "task_type",
        "user_name",
        "client_name",
        "result",
        "status",
        "date_initiated",
        "date_done",
        "export_duration"
    ],
    config: {
        smart_export: {
            isVisible: true,
            label: "Report Name",
            class: "width-200px",
            searchKey: "smart_export.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "smart_export",
            commonSearchKey: "smart_export",
            commonSearchObjectKey: "name"
        },
        task_name: {
            isVisible: true,
            label: "Task Name",
            class: "width-140px",
            searchKey: "fca_task_manager.task_name",
            filterIdKey: "task_name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "task_name",
            commonSearchKey: "task_name",
            commonSearchObjectKey: "name"
        },
        task_type: {
            isVisible: true,
            label: "Task Type",
            class: "width-160px",
            searchKey: "fca_task_manager.task_type",
            filterIdKey: "task_type",
            type: "string",
            hasWildCardSearch: false,
            hasCommonSearch: true,
            getListTable: "task_type",
            commonSearchKey: "task_type",
            commonSearchObjectKey: "name"
        },
        user_name: {
            isVisible: true,
            label: "User Name",
            class: "width-160px",
            searchKey: "users.name",
            filterIdKey: "user",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "user",
            commonSearchKey: "user_name",
            commonSearchObjectKey: "name"
        },
        client_name: {
            isVisible: true,
            label: "Client Name",
            class: "width-160px",
            searchKey: "clients.name",
            type: "string",
            hasWildCardSearch: false,
            hasCommonSearch: false,
            getListTable: "client_name",
            commonSearchKey: "client_name",
            commonSearchObjectKey: "name"
        },
        result: {
            isVisible: true,
            label: "Result",
            class: "width-160px",
            searchKey: "fca_task_manager.result",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "result",
            commonSearchKey: "result",
            commonSearchObjectKey: "name"
        },
        status: {
            isVisible: true,
            label: "Status",
            class: "width-160px",
            searchKey: "fca_task_manager.status",
            filterIdKey: "status",
            type: "string",
            hasWildCardSearch: false,
            hasCommonSearch: true,
            getListTable: "status",
            commonSearchKey: "status",
            commonSearchObjectKey: "name"
        },
        date_initiated: {
            isVisible: true,
            label: "Initiated Time",
            class: "width-160px",
            searchKey: "fca_task_manager.date_initiated",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "date_initiated",
            commonSearchKey: "date_initiated",
            commonSearchObjectKey: "date_initiated"
        },
        date_done: {
            isVisible: true,
            label: "Completed Time",
            class: "width-160px",
            searchKey: "fca_task_manager.date_done",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "date_done",
            commonSearchKey: "date_done",
            commonSearchObjectKey: "date_done"
        },
        export_duration: {
            isVisible: true,
            label: "Time Taken",
            class: "width-160px",
            searchKey: "fca_task_manager.duration",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "export_duration",
            commonSearchKey: "export_duration",
            commonSearchObjectKey: "export_duration"
        }
    }
};
